import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent
} from '@angular/common/http';
import { Injectable, InjectionToken, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { isNil } from 'lodash';

export const DEFAULT_TIMEOUT = new InjectionToken<number>('defaultTimeout');

@Injectable()
export class HttpTimeoutInterceptorService implements HttpInterceptor {
  constructor(@Inject(DEFAULT_TIMEOUT) protected defaultTimeout: number) {
    if (isNil(defaultTimeout)) {
      this.defaultTimeout = 120000;
    }
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const numericTimeout = Number(this.defaultTimeout);
    return next.handle(req).pipe(timeout(numericTimeout));
  }

  getTimeout() {
    return this.defaultTimeout;
  }
}
